import { httpClient } from '../commons/httpClient'

export interface DiscountInfo {
  code: string
  amount?: number
  currency?: string
  percent?: number
  pageDescription?: string
  invoiceDescription?: string
  name?: string
  discountMonthlyFee: boolean
  discountSeatFee: boolean
  discountSetupFee: boolean
}

const getDiscountCodeInfo = (discountCode: string | null): Promise<DiscountInfo> => {
  return httpClient.get(`/AdminSignup/DiscountInfo/${discountCode}`)
}

export default getDiscountCodeInfo
